import React from "react";
import { toast } from "react-toastify";
import useFormSubmit from "../../../../hooks/useFormSubmit";
import NimbusModal from "../../../../fragments/NimbusModal";
import CancelButton from "../../../../fragments/Buttons/CancelButton";
import SubmitButton from "../../../../fragments/Buttons/SubmitButton";
import alertConfiguration from "../../../../utils/alertsUtils";
import { deletePaqueteMarketplace } from "../../../../services/Api/MarketPlace/Paquetes";

const EliminarPaqueteModal = ({ isOpen, setIsOpen, nombre, obtenerPaquetes, paqueteId }) => {
  const configuracionPersonalizadaSubmit = async () => {
    try {
      await deletePaqueteMarketplace(paqueteId);
      toast.success("Paquete eliminado correctamente.", alertConfiguration);
      obtenerPaquetes();
      setIsOpen(false);
    } catch (error) {
      console.log(error);
      setIsOpen(false);
    }
  };
  const [formStatus, handleSubmit] = useFormSubmit(configuracionPersonalizadaSubmit);
  return (
    <NimbusModal isOpen={isOpen}>
      <h1 className="text-nimbusDark font-bold">Eliminar paquete</h1>
      <p className="w-96 px-4 sm:px-2">
        Al eliminar este paquete, será retirado también de todas las estructuras donde haya sido asignado.
      </p>
      <p className="w-96 px-4 text-black break-words font-bold">{nombre}</p>
      <div className="w-96 px-4 text-center mb-6">
        <p className="text-nimbusDark font-bold">¿Está seguro que desea eliminar este paquete?</p>
      </div>
      <div className="flex justify-center gap-x-4">
        <CancelButton text="Cancelar" bgColor="bg-divider" onClick={() => setIsOpen(false)} />
        <SubmitButton text="Aceptar" disabled={formStatus === "submitting"} onClick={handleSubmit} />
      </div>
    </NimbusModal>
  );
};

export default EliminarPaqueteModal;
